/* eslint-disable no-unused-vars */
import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import TeamIllustrationSrc from "images/team-illustration-2.svg";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg";

const Container = styled.div`
  ${tw`relative`}
  background: #FDFAF6;
`;

const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24 px-8 items-center`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;

const ImageColumn = styled(Column)`
  ${tw`md:w-5/12 flex-shrink-0 relative`}
`;

const TextColumn = styled(Column)(props => [
  tw`md:w-6/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.img(props => [
  tw`w-full rounded-2xl`,
  props.imageShadow && css`box-shadow: 0 20px 60px rgba(12, 42, 41, 0.12);`,
]);

const DecoratorBlob = styled(SvgDotPattern)`
  ${tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current -z-10`}
  color: #B3E8E2;
`;

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const SubheadingStyled = styled(SubheadingBase)`
  ${tw`text-center md:text-left`}
  color: #2A9D8F;
  font-family: 'Nunito', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.8rem;
`;

const Heading = styled(SectionHeading)`
  ${tw`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`}
  font-family: 'Cormorant Garant', serif;
  color: #0C2A29;
`;

const Description = styled.p`
  ${tw`mt-6 text-center md:text-left text-sm md:text-base lg:text-base font-medium leading-relaxed`}
  color: #264F5D;
  font-family: 'Nunito', sans-serif;
`;

const ContactButton = styled.a`
  ${tw`mt-8 inline-flex items-center font-bold px-8 py-4 rounded-lg text-white no-underline transition duration-300`}
  background-color: #E1609E;
  font-family: 'Nunito', sans-serif;
  font-size: 0.95rem;
  &:hover {
    background-color: #A82B6F;
    box-shadow: 0 8px 25px rgba(225, 96, 158, 0.35);
    transform: translateY(-1px);
  }
  &:active {
    transform: translateY(0);
  }
`;

export default ({
  subheading = "Our Expertise",
  heading = (
    <>
      Designed & Developed by <span tw="text-primary-500">Professionals.</span>
    </>
  ),
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  imageSrc = TeamIllustrationSrc,
  imageRounded = true,
  imageBorder = false,
  imageShadow = true,
  imageCss = null,
  imageDecoratorBlob = false,
  imageDecoratorBlobCss = null,
  textOnLeft = true,
  primaryButtonText = "Book an Appointment",
  primaryButtonUrl = "https://wa.me/+919815662600",
}) => {
  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          <Image
            css={imageCss}
            src={imageSrc}
            imageBorder={imageBorder}
            imageShadow={imageShadow}
            imageRounded={imageRounded}
            alt="Kaushal Clinic — Women's Healthcare"
          />
          {imageDecoratorBlob && <DecoratorBlob css={imageDecoratorBlobCss} />}
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            <SubheadingStyled>{subheading}</SubheadingStyled>
            <Heading>{heading}</Heading>
            <Description>{description}</Description>
            {primaryButtonText && (
              <ContactButton href={primaryButtonUrl} target="_blank" rel="noopener noreferrer">
                {primaryButtonText}
              </ContactButton>
            )}
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
